import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const RegEngagementHubPage = lazy(() =>
  import('../pages/reg-engagement').then((m) => ({ default: m.RegEngagementHubPage }))
)
const EngagementsPage = lazy(() =>
  import('../pages/reg-engagement').then((m) => ({ default: m.EngagementsPage }))
)
const RegDeadlinesPage = lazy(() =>
  import('../pages/reg-engagement').then((m) => ({ default: m.RegDeadlinesPage }))
)
const RegSubmissionsPage = lazy(() =>
  import('../pages/reg-engagement').then((m) => ({ default: m.RegSubmissionsPage }))
)

export const regEngagementRoutes: RouteObject[] = [
  {
    path: '/reg-engagement',
    children: [
      { index: true, element: <RegEngagementHubPage /> },
      { path: 'hub', element: <RegEngagementHubPage /> },
      { path: 'engagements', element: <EngagementsPage /> },
      { path: 'deadlines', element: <RegDeadlinesPage /> },
      { path: 'submissions', element: <RegSubmissionsPage /> },
    ],
  },
]
